var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.componentsList),function(item){return _c('div',{key:item.id},[(item.id)?_c(item.component,{tag:"component"}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }